export const LOCAL_STORAGE_PRIVACY_COOKIE = 'jdaUserPrivacyPermissions';